import { render, staticRenderFns } from "./FoundationPaymentReport.vue?vue&type=template&id=5afa4596"
import script from "./FoundationPaymentReport.vue?vue&type=script&lang=js"
export * from "./FoundationPaymentReport.vue?vue&type=script&lang=js"
import style0 from "./FoundationPaymentReport.vue?vue&type=style&index=0&id=5afa4596&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports